import { ArrowDownNarrowWide, ArrowUpNarrowWide } from "lucide-react";
import React, { ReactNode } from "react";
import { DefaultFilterType } from "../../../types/PageFilterTypes";

interface SortableTHProps {
  sortKey: string;
  updateFilter: (filter: DefaultFilterType) => void;
  filters: DefaultFilterType;
  children: ReactNode;
  classNames?: string;
}

export const SortableTH: React.FC<SortableTHProps> = ({
  sortKey,
  updateFilter,
  filters,
  children,
  classNames,
}) => {
  return (
    <th
      onClick={() =>
        updateFilter({
          sort:
            filters.sort === `${sortKey}|desc`
              ? `${sortKey}|asc`
              : `${sortKey}|desc`,
        })
      }
      className={`${classNames} pr-6 py-4 text-left text-xs cursor-pointer font-bold uppercase tracking-wider text-gray-500 text-nowrap`}
    >
      {children}
      {filters.sort?.split("|")[0] === sortKey && (
        <span>
          {filters.sort === `${sortKey}|asc` ? (
            <ArrowDownNarrowWide className="inline w-4 h-4 ml-1 cursor-pointer" />
          ) : (
            <ArrowUpNarrowWide className="inline w-4 h-4 ml-1 cursor-pointer" />
          )}
        </span>
      )}
    </th>
  );
};
